// extracted by mini-css-extract-plugin
module.exports = {"select":"checkbox-dropdown_select__Ick_2","dropdown":"checkbox-dropdown_dropdown__6vgPP"};